import React, { useState } from 'react';
import type { FormEvent } from 'react';
import { requestJson } from '../../api/http';

export function WaitlistForm() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [products, setProducts] = useState<string[]>([]);
  const [note, setNote] = useState('');
  const [website, setWebsite] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true); setError('');
    try {
      await requestJson('/v1/auth/waitlist', { method: 'POST', body: JSON.stringify({ email, name, products, note, website }) });
      setSubmitted(true);
    } catch { setError('Unable to join the waitlist. Please check your details and try again.'); }
    finally { setBusy(false); }
  }
  if (submitted) return <p role="status">Thanks — check your email.</p>;
  return <form onSubmit={submit}>
    <h2>Join the founding beta</h2>
    <p>Every auteur needs a studio. Work alongside us on a real project while the products finish. Founding Studio seats are paid and limited; we invite people in waitlist order.</p>
    <label htmlFor="waitlist-email">Email</label><input id="waitlist-email" type="email" required maxLength={254} value={email} onChange={e => setEmail(e.target.value)} />
    <label htmlFor="waitlist-name">Name</label><input id="waitlist-name" required maxLength={200} value={name} onChange={e => setName(e.target.value)} />
    <fieldset><legend>Products you want</legend>{[['studio', 'Studio'], ['story', 'Story'], ['prep', 'Prep'], ['film', 'Film'], ['edit', 'Edit'], ['conductor', 'Conductor'], ['launch', 'Launch'], ['learning', 'Learning'], ['build', 'Build'], ['game', 'Game'], ['science', 'Science'], ['single', 'Other single products']].map(([id, label]) => <label key={id}><input type="checkbox" checked={products.includes(id)} onChange={e => setProducts(e.target.checked ? [...products, id] : products.filter(p => p !== id))} />{label}</label>)}</fieldset>
    <label htmlFor="waitlist-note">Note (optional)</label><textarea id="waitlist-note" maxLength={2000} value={note} onChange={e => setNote(e.target.value)} />
    <div style={{ position: 'absolute', left: '-10000px' }} aria-hidden="true"><label htmlFor="waitlist-website">Website</label><input id="waitlist-website" tabIndex={-1} autoComplete="off" value={website} onChange={e => setWebsite(e.target.value)} /></div>
    {error && <p role="alert">{error}</p>}<button disabled={busy || !products.length}>{busy ? 'Joining…' : 'Join waitlist'}</button>
  </form>;
}
